module.exports = __webpack_public_path__ + "img/plugin_verification_code.png";